export class Suggestion {
  client: string;
  term: string;
  enable: boolean;
  id: number;
  crated: string;
}
